/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Button, Container, Row, Col, Card, CardBody } from "reactstrap";

class Hero extends React.Component {
  render() {
    return (
      <>
        <div className="position-relative">
          {/* Hero for FREE version */}
          <section className="section section-hero section-shaped">
            {/* Background circles */}
            <div className="shape shape-style-1 shape-default">
              <span className="span-150" />
              <span className="span-50" />
              <span className="span-50" />
              <span className="span-75" />
              <span className="span-100" />
              <span className="span-75" />
              <span className="span-50" />
              <span className="span-100" />
              <span className="span-50" />
              <span className="span-100" />
            </div>
            <Container className="shape-container d-flex align-items-center py-lg">
              <div className="col px-0">
                <Row className="align-items-center justify-content-center">
                  <Col className="text-center" lg="8">
                    <h1 className="display-3 text-white font-weight-bold mb-4">
                      Bienvenue chez
                    </h1>
                    <img
                        alt="Solution Nügaz - Votre partenaire énergétique"
                        className="img-center img-fluid mb-4"
                        src={require("assets/img/nugazLogoHomepage.png")}
                        style={{maxWidth: '400px'}}
                    />
                    <p className="lead text-white opacity-8 mt-4 mb-5">
                      Votre partenaire de confiance pour l'approvisionnement en gaz naturel au Québec. 
                      Excellence, fiabilité et service personnalisé depuis plus de 14 ans.
                    </p>
                    <div className="btn-wrapper">
                      <Button
                        className="btn-white btn-icon mb-3 mb-sm-0"
                        color="default"
                        size="lg"
                        href="mailto:nvincent@nugaz.com"
                      >
                        <span className="btn-inner--icon mr-2">
                          <i className="ni ni-email-83" />
                        </span>
                        <span className="btn-inner--text">Contactez-nous</span>
                      </Button>
                      <Button
                        className="btn-outline-white btn-icon mb-3 mb-sm-0 ml-3"
                        color="default"
                        size="lg"
                        href="tel:+4189530318"
                      >
                        <span className="btn-inner--icon mr-2">
                          <i className="ni ni-mobile-button" />
                        </span>
                        <span className="btn-inner--text">418-407-0863</span>
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  points="2560 0 2560 100 0 100"
                  className="fill-white"
                  
                />
              </svg>
            </div>
          </section>

          <section className="section pb-0 bg-gradient-white" >
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-lg-2 ml-lg-auto" md="6">
                  <div className="position-relative pl-md-5">
                    <img
                      alt="Innovation et expertise énergétique"
                      className="img-center img-fluid"
                      src={require("assets/img/ill/ill-2.svg").default}
                    />
                  </div>
                </Col>
                <Col className="order-lg-1" lg="6">
                  <div className="d-flex px-3" style={{marginBottom:40}}>
                    <div>
                      <div className="icon icon-lg icon-shape bg-gradient-warning shadow rounded-circle text-white">
                        <i className="ni ni-building text-white" />
                      </div>
                    </div>
                    <div className="pl-4">
                      <h2 className="display-3 text-black font-weight-bold mb-4">Qui sommes-nous?</h2>
                      
                      <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body p-4">
                          <h5 className="text-warning font-weight-bold mb-3">
                            <i className="ni ni-atom mr-2"></i>Une histoire d'excellence énergétique
                          </h5>
                          <p className="text-muted mb-0">
                            L'entreprise Solutions Nügaz Inc est née de l'entrepreneurship de son propriétaire Nicolas Vincent.
                            Après avoir passé 9 années chez Gaz Métro, Nicolas fonde Nügaz en novembre 2010 pour offrir le
                            service de fourniture à la clientèle de Gaz Métro.
                          </p>
                        </div>
                      </div>

                      <div className="timeline">
                        <div className="timeline-item">
                          <div className="timeline-badge bg-success">
                            <i className="ni ni-calendar-grid-58"></i>
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h6 className="timeline-title text-success font-weight-bold">2013 - Premier partenariat</h6>
                            </div>
                            <div className="timeline-body">
                              <p className="text-muted">
                                En novembre 2013, Nügaz entre en partenariat avec la compagnie Shell Energy North America
                                (Canada) Inc pour desservir sa clientèle commerciale, institutionnelle et industrielle de la province de
                                Québec.
                              </p>
                            </div>
                          </div>
                        </div>
                        
                        <div className="timeline-item">
                          <div className="timeline-badge bg-primary">
                            <i className="ni ni-trophy"></i>
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h6 className="timeline-title text-primary font-weight-bold">2025 - Nouveau partenariat canadien</h6>
                            </div>
                            <div className="timeline-body">
                              <p className="text-muted">
                                En février 2025, Nügaz signe un nouveau partenariat avec Emera Energy L.P., une compagnie fièrement canadienne, marquant une nouvelle étape dans le développement de l'entreprise et notre engagement envers l'excellence.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card bg-gradient-info shadow-lg border-0 mt-4">
                        <div className="card-body p-4">
                          <h6 className="text-white font-weight-bold mb-2">
                            <i className="ni ni-chart-bar-32 mr-2"></i>Notre portée actuelle
                          </h6>
                          <p className="text-white opacity-8 mb-0">
                            Afin d'accroître l'offre d'Emera Energy L.P. à une plus vaste clientèle, Nugaz développe maintenant tout le
                            marché du Québec pour les consommateurs de 7 500 à 3 500 000 m³/année.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white" points="2560 0 2560 100 0 100"
                  
                />
              </svg>
            </div>
          </section>

         
        </div>
      </>
    );
  }
}

export default Hero;
